// extracted by mini-css-extract-plugin
var _1 = "MyifpavritsQWorfDiw1";
var _2 = "Uitce_lsIWVnSLsjKb6x";
var _3 = "LQt0QokvvuHQfSIBIImK";
var _4 = "Vwdguw703RfznduDUXWZ";
var _5 = "B_dcYWl8RJBR9dOKhPM9";
var _6 = "HpYpBhXCf8QXqnec8ORm";
var _7 = "HxVlRWRkaklVoFnyWGEz";
var _8 = "L7NMxPTnNXEpJuA4jpsU";
export { _1 as "bluePill", _2 as "disabledPill", _3 as "greenPill", _4 as "pill", _5 as "pillText", _6 as "redPill", _7 as "silverPill", _8 as "whiteGreenPill" }
